import { createContext, useContext, useMemo, useState } from 'react';

const LoginStateContext = createContext(null);

export function LoginStateProvider({ children }) {
  const [loginState, setLoginState] = useState({});
  const value = useMemo(() => [loginState, setLoginState], [loginState]);
  return (
    <LoginStateContext.Provider value={value}>
      {children}
    </LoginStateContext.Provider>
  );
}

export function useLoginState() {
  const context = useContext(LoginStateContext);
  if (context === null) {
    throw new Error('useLoginState must be used within a LoginStateProvider');
  }
  return context;
}
